import { ShoppingBag, TrendingUp, BellRing, Play } from "lucide-react";

/**
 * Ana sayfa hero görseli — görsel dosyası yerine marka stilinde CSS/SVG
 * kompozisyon: canlı performans kartı + sipariş bildirimi + reklam kreatifi.
 */
export default function HeroGorsel() {
  const barlar = [34, 48, 42, 60, 55, 72, 66, 80, 74, 92, 86, 100];
  return (
    <div className="relative w-[320px] md:w-[420px] xl:w-[480px] select-none mt-16 mb-12 md:mt-4 md:mb-8" aria-hidden="true">
      {/* nokta ızgara arka plan */}
      <div className="absolute -inset-8 [background-image:radial-gradient(#00000022_1px,transparent_1px)] [background-size:14px_14px] rounded-full opacity-70" />

      {/* Ana kart: canlı performans */}
      <div className="relative border-3 border-black bg-white shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] rotate-1 hover:rotate-0 transition-transform duration-300">
        <div className="flex items-center justify-between border-b-3 border-black px-4 py-2.5">
          <div className="flex items-center gap-2">
            <span className="w-2.5 h-2.5 rounded-full bg-[#9EFF00] border border-black animate-pulse" />
            <span className="font-mono text-[10px] font-bold tracking-widest">EYLÜL 2026</span>
          </div>
          <span className="font-mono text-[10px] text-neutral-500">Tek marka · 3 kanal</span>
        </div>
        <div className="p-4 md:p-5 space-y-4">
          <div className="flex items-end justify-between gap-3">
            <div>
              <div className="font-mono text-[10px] font-bold text-neutral-500 tracking-widest">REKLAM KAYNAKLI CİRO</div>
              <div className="font-black text-2xl md:text-3xl xl:text-4xl tracking-tight leading-none mt-1">₺9.000.000</div>
              <div className="font-mono text-[10px] font-bold text-neutral-600 mt-1.5">Reklam harcaması ₺850.000</div>
            </div>
            <div className="bg-[#9EFF00] border-2 border-black px-2.5 py-1.5 shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] text-right">
              <div className="font-mono text-[9px] font-bold tracking-widest">ROAS</div>
              <div className="font-black text-xl leading-none flex items-center gap-1">10,6x <TrendingUp className="w-4 h-4" /></div>
            </div>
          </div>
          <svg viewBox="0 0 240 90" className="w-full h-24 md:h-28">
            {barlar.map((v, i) => (
              <g key={i}>
                <rect x={i * 20 + 2} y={90 - v * 0.82} width="14" height={v * 0.82} fill={i === barlar.length - 1 ? "#9EFF00" : "#111"} stroke="#000" strokeWidth="1.5" />
              </g>
            ))}
            <polyline points={barlar.map((v, i) => `${i * 20 + 9},${86 - v * 0.82}`).join(" ")} fill="none" stroke="#9EFF00" strokeWidth="3" strokeLinejoin="round" style={{ filter: "drop-shadow(1px 1px 0 #000)" }} />
          </svg>
          <div className="flex flex-wrap gap-2">
            {[["Meta", "9,8x"], ["Google", "12,4x"], ["TikTok", "7,9x"]].map(([k, r]) => (
              <span key={k} className="inline-flex items-center gap-1.5 border-2 border-black px-2 py-1 font-mono text-[10px] font-bold bg-neutral-50">
                {k} <span className="text-neutral-500">ROAS</span> {r}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Sipariş bildirimi — sağ üst */}
      <div className="absolute -top-20 -right-2 md:-top-8 md:-right-10 w-40 md:w-52 border-3 border-black bg-white p-3 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] -rotate-3 animate-[dj-float_6s_ease-in-out_infinite] z-10">
        <div className="flex items-center gap-2">
          <span className="w-8 h-8 border-2 border-black bg-[#9EFF00] flex items-center justify-center"><ShoppingBag className="w-4 h-4" /></span>
          <div className="leading-tight">
            <div className="font-black text-xs">Yeni sipariş</div>
            <div className="font-mono text-[10px] text-neutral-500">Shopify · Instagram Reels</div>
          </div>
          <BellRing className="w-3.5 h-3.5 ml-auto text-neutral-400" />
        </div>
        <div className="mt-2 flex items-center justify-between">
          <span className="font-black text-lg">+₺3.480</span>
          <span className="bg-black text-[#9EFF00] font-mono text-[9px] font-bold px-1.5 py-0.5">SEPET ↑ %38</span>
        </div>
      </div>

      {/* Reklam kreatifi — sol alt */}
      <div className="absolute -bottom-8 -left-4 md:-left-10 w-36 md:w-40 border-3 border-black bg-white p-2 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] rotate-3 animate-[dj-float_7s_ease-in-out_infinite_1s] z-10">
        <div className="relative aspect-[4/5] border-2 border-black bg-[linear-gradient(135deg,#9EFF00_0%,#d7ff8a_60%,#fff_100%)] overflow-hidden">
          <div className="absolute inset-x-2 bottom-2 space-y-1">
            <div className="h-1.5 w-3/4 bg-black" /><div className="h-1.5 w-1/2 bg-black/60" />
          </div>
          <span className="absolute top-2 left-2 font-mono text-[8px] font-bold bg-white border border-black px-1">REELS</span>
          <span className="absolute inset-0 m-auto w-8 h-8 border-2 border-black bg-white flex items-center justify-center"><Play className="w-3.5 h-3.5" /></span>
        </div>
        <div className="mt-1.5 flex items-center justify-between font-mono text-[9px] font-bold">
          <span>CTR</span><span className="bg-[#9EFF00] border border-black px-1">%3,2</span>
        </div>
      </div>

      {/* Yönetilen bütçe rozeti — sağ alt */}
      <div className="absolute -bottom-12 right-0 md:-right-8 border-3 border-black bg-black text-white px-3 py-2 shadow-[4px_4px_0px_0px_rgba(158,255,0,1)] rotate-2 z-10 leading-tight">
        <div className="font-mono text-[9px] font-bold tracking-widest text-[#9EFF00]">YÖNETİLEN REKLAM BÜTÇESİ</div>
        <div className="font-black text-lg md:text-xl leading-none mt-1">4,8M $+</div>
        <div className="font-mono text-[9px] font-bold text-neutral-300 mt-1">4 yıldır her ay 100.000 $</div>
      </div>

      <div className="absolute top-1/2 -left-14 w-6 h-6 bg-[#9EFF00] border-3 border-black rotate-45 hidden xl:block" />
      <div className="absolute -top-3 left-1/3 w-3 h-3 bg-black rounded-full hidden xl:block" />
    </div>
  );
}
